// removed by extract-text-webpack-plugin
module.exports = {"completed":"TaskDialog__completed___2mQQI","content":"TaskDialog__content___3fDTd","date":"TaskDialog__date___1Ehr4","title":"TaskDialog__title___gP6qQ","titleText":"TaskDialog__titleText___2OYU8","label":"TaskDialog__label___2mSNC","newComment":"TaskDialog__newComment___3Gh9i","inlineOval":"TaskDialog__inlineOval___3GuUW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TaskDialog/TaskDialog.scss
// module id = 1200
// module chunks = 1